import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import errorBoundary, {
  ErrorBoundaryProps,
} from 'client/shared/decorators/error-boundary'

import List, { HeaderRank } from 'client/bookmate/blocks/list'
import { Book } from 'client/shared/blocks/book'
import AudioBook from 'client/bookmate/blocks/audiobook'
import Spacer from 'client/shared/blocks/spacer'

import { BookProps } from 'client/shared/types/book'
import { AudiobookProps } from 'client/shared/types/audiobook'
import { ResourceName } from 'client/shared/types/resource'
import { Dispatch, State as ConnectedState } from 'shared/types/redux'
import { sendOnClickAnalytics } from 'shared/tools/analytics-helper'

type Props = {
  resourceType: ResourceName
  books: BookProps[]
  audiobooks: AudiobookProps[]
  dispatch: Dispatch
  userId: number
  resourceUuid: string
  headerRank: HeaderRank
} & ErrorBoundaryProps

class ResourceOtherVersionsBox extends Component<Props> {
  render(): JSX.Element | null {
    const { books, audiobooks, headerRank } = this.props

    if (!books?.length && !audiobooks?.length) return null

    return (
      <Fragment>
        <List headerRank={headerRank} header="book.other_versions">
          {audiobooks?.map((audiobook, index) =>
            this.renderAudiobook(audiobook, index + 1),
          )}
          {books?.map((book, index) => this.renderBook(book, index + 1))}
        </List>
        <Spacer size={56} />
      </Fragment>
    )
  }

  renderBook(book, index) {
    const { dispatch, resourceType, userId, resourceUuid } = this.props
    return (
      <Book
        onClick={() =>
          sendOnClickAnalytics({
            dispatch,
            resourceType,
            itemUuid: book.uuid,
            screenName: `${resourceType}_other_versions`,
            position: index,
            userId,
            resourceUuid,
          })
        }
        book={book}
        kind="list"
        coverSize={88}
        key={book.uuid}
      />
    )
  }

  renderAudiobook(audiobook, index) {
    const { dispatch, resourceType, userId, resourceUuid } = this.props

    return (
      <AudioBook
        onClick={() =>
          sendOnClickAnalytics({
            dispatch,
            resourceType,
            itemUuid: audiobook.uuid,
            screenName: `${resourceType}_other_versions`,
            position: index,
            userId,
            resourceUuid,
          })
        }
        audiobook={audiobook}
        kind="list"
        coverSize={88}
        key={audiobook.uuid}
      />
    )
  }
}

const wrapper = compose(
  connect((state: ConnectedState, ownProps) => {
    const { otherVersions } = state[ownProps.resourceType]
    return {
      userId: state.currentUser.data.id,
      books: otherVersions.books,
      audiobooks: otherVersions.audiobooks,
    }
  }),
  errorBoundary,
)

export default wrapper(ResourceOtherVersionsBox)
